export default __webpack_public_path__ + "img/eggplant.22113a1f.svg";